import { render, staticRenderFns } from "./kdxContentBar.g.vue?vue&type=template&id=3362b74e&scoped=true"
import script from "./kdxContentBar.g.vue?vue&type=script&lang=js"
export * from "./kdxContentBar.g.vue?vue&type=script&lang=js"
import style0 from "./kdxContentBar.g.vue?vue&type=style&index=0&id=3362b74e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3362b74e",
  null
  
)

export default component.exports